<mp-root-module-nav *mpHeaderElement="'left'" label="Plattformkataloge" />

<mp-platformcatalogs-search-bar
  [searchTerm]="searchTerm"
  [field]="field"
  *mpHeaderElement="'center'"
  (searched)="handleFilterChanges($event)"
/>

<div
  class="mp-page mp-page--scrollable-wide-view mp-page--border"
  *ngrxLet="plattformkatalogFilter$ as plattformkatalogFilter"
>
  <div class="mp-page__main">
    <mp-aside-filters
      class="mp-page__aside-filters"
      (filtersReset)="resetFilter()"
      [filtersSummary]="plattformkatalogFilter | mpctmPlatformCatalogsAsideFiltersSummary"
    >
      <mp-plattformkataloge-filter-area
        [filter]="plattformkatalogFilter"
        [dataSources]="dataSources$ | async"
        (filterChanges)="handleFilterChanges($event)"
      />
    </mp-aside-filters>

    <div class="mp-page__content mp-page--padding">
      @if ((isLoading$ | async) === false) {
        <ng-container
          *ngrxLet="{
            aktualisierungen: aktualisierungen$.state$,
            deletedAktualisierungen: deletedAktualisierungen$.state$,
            dirty: dirty$.state$,
            platformCatalogs: plattformKataloge$,
          } as vm"
        >
          <div class="page-list-header">
            <mp-list-header
              class="page-list-header__results mp-list-header--spaced"
              headerPlaceholder="Plattformkataloge"
              [totalItemsQuantity]="vm.platformCatalogs.length"
            />
            <div class="page-list-header__action-buttons">
              @if (editMode !== true && hasManagePlatformCatalogsPermission()) {
                <button mat-flat-button color="accent" (click)="setCreateMode(true)">
                  <mat-icon class="button-icon">menu_book</mat-icon>
                  <span>Plattformkatalog erstellen</span>
                </button>
              }
            </div>
          </div>
          @if (editMode === true) {
            <mp-plattformkatalog-create
              class="plattformkatalog-create"
              [nameControl]="editModeFormControl"
              (created)="handleCreated($event)"
              (cancelled)="setCreateMode(false)"
            />
          }
          <mat-accordion #accordion="matAccordion">
            @for (plattformKatalog of vm.platformCatalogs; track plattformKatalog.catalogId) {
              <ng-container *ngrxLet="(activePlatformCatalogId$ | async) === plattformKatalog.catalogId as isActive">
                <mp-platformcatalog-panel
                  class="platformcatalog-panel"
                  [expanded]="isActive"
                  [disabled]="plattformKatalog.status === 'Publication'"
                  [countInfo]="plattformKatalog | mpPlatformCatalogCountInfo"
                  [editMode]="editMode === plattformKatalog.catalogId"
                  [nameControl]="editModeFormControl"
                  [activeTab]="getActiveTab()"
                  (editModeChange)="!$event && cancelEditMode(plattformKatalog.catalogId)"
                  (activeTabChange)="navigateToTab(plattformKatalog.catalogId, $event)"
                  (save)="changePlatformCatalogName(plattformKatalog.catalogId, $event)"
                  (afterExpand)="handleKatalogExpanded(plattformKatalog.catalogId)"
                  (afterCollapse)="handleKatalogCollapsed(plattformKatalog.catalogId)"
                  #expansionPanel
                >
                  <!-- Header -->
                  <mat-panel-title>
                    <span class="header-title" [class.header-title--error]="plattformKatalog.status === 'Error'">
                      @if (plattformKatalog.status !== 'Error') {
                        <mat-icon class="header-icon">menu_book</mat-icon>
                        <h4 class="header-name truncate" [title]="plattformKatalog?.name">
                          {{ plattformKatalog?.name }}
                        </h4>
                      } @else {
                        <mat-icon class="header-icon">warning_ember</mat-icon>
                        <h4 class="header-name truncate" [title]="plattformKatalog?.name">
                          {{ plattformKatalog?.name }}
                          <span class="fehlermeldung truncate" title="Fehler bei der Veröffentlichung"
                            >Fehler bei der Veröffentlichung</span
                          >
                        </h4>
                      }
                      @if (
                        plattformKatalog.catalogsUpdatedCount -
                          (vm.deletedAktualisierungen[plattformKatalog.catalogId] || 0);
                        as available
                      ) {
                        <mp-badge-updates
                          [available]="available"
                          [updated]="vm.aktualisierungen[plattformKatalog.catalogId] || 0"
                        />
                      }
                    </span>
                  </mat-panel-title>
                  <mat-panel-description>
                    @if (plattformKatalog.hasUnpublishedChanges && plattformKatalog.status === 'Ready') {
                      <div class="update-col">Änderungen erkannt. Bitte erneut veröffentlichen.</div>
                    }
                    <div class="action-col">
                      <div class="date-col">
                        @if (plattformKatalog?.lastPublication && plattformKatalog?.inPublicationSince === null) {
                          <p class="header-date">
                            zuletzt
                            {{ plattformKatalog?.lastPublication | humanizeRelativeDate: { whenInRange: { days: 2 } } }}
                          </p>
                        }
                        @if (plattformKatalog?.inPublicationSince !== null) {
                          <p class="header-date">
                            {{
                              plattformKatalog?.inPublicationSince | humanizeRelativeDate: { whenInRange: { days: 2 } }
                            }}
                          </p>
                        }
                      </div>
                      <mp-publish-button
                        [disabled]="
                          !(
                            hasPublishCatalogsPermission() &&
                            (plattformKatalog?.hasUnpublishedChanges ||
                              vm.aktualisierungen[plattformKatalog.catalogId] ||
                              vm.dirty[plattformKatalog.catalogId])
                          )
                        "
                        [pending]="plattformKatalog?.status === 'Publication'"
                        (publish)="publishPlattformKatalog(plattformKatalog.catalogId)"
                      />
                      @if (hasManagePlatformCatalogsPermission()) {
                        <button
                          mat-stroked-button
                          class="actions-button"
                          (click)="$event.stopPropagation(); setEditMode(plattformKatalog)"
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                      }
                      @if (hasManagePlatformCatalogsPermission()) {
                        <button
                          mat-stroked-button
                          class="actions-button"
                          [disabled]="plattformKatalog.assignedOrganizationsCount > 0"
                          (click)="$event.stopPropagation(); deletePlatformCatalog(plattformKatalog)"
                          [matTooltipDisabled]="plattformKatalog.assignedOrganizationsCount === 0"
                          matTooltip="Plattformkataloge mit zugewiesenen Organisationen können nicht gelöscht werden"
                        >
                          <mat-icon svgIcon="trash_can_outline" />
                        </button>
                      }
                    </div>
                  </mat-panel-description>
                  <!-- Buttons -->
                  @if (hasPublishCatalogsPermission()) {
                    <mp-action-button
                      platformcatalog-panel-action-button
                      icon="cached"
                      label="Reindexieren"
                      [disabled]="plattformKatalog.status === 'Publication' || editMode === plattformKatalog.catalogId"
                      (buttonClick)="reindexPlatformCatalog(plattformKatalog)"
                    />
                  }

                  @let isDisabled =
                    !hasManagePlatformCatalogsPermission() ||
                    plattformKatalog.status === 'Publication' ||
                    editMode === plattformKatalog.catalogId;
                  <mp-actions-slide-toggle-button
                    platformcatalog-panel-action-button
                    icon="published_with_changes"
                    label="Datenquellenübergreifend indexieren"
                    [checked]="plattformKatalog.isSearchMultipleDataSourcesActive"
                    [disabled]="isDisabled"
                    (buttonClick)="toggleMultipleDataSourcesSearchActive(plattformKatalog)"
                  />

                  <!-- Content -->
                  @if (isActive) {
                    <router-outlet />
                  }
                </mp-platformcatalog-panel>
              </ng-container>
            }
          </mat-accordion>
        </ng-container>
      } @else {
        <mp-spinner />
      }
    </div>
  </div>
</div>
